import React, { useState } from 'react';
import axios from 'axios';
import Repli from './Repli';
import LiensEditor from './LiensEditor';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const vide = () => ({ id: '', icone: '📝', titre: '', texte: '', lien: '', lien_titre: '', liens: [] });

// Iter 557 (Kamel) — 📚 bibliothèque de rubriques types, insérables dans n'importe quel voyage.
export const ModelesPanel = ({ modeles, setModeles, getAuthConfig }) => {
  const [edit, setEdit] = useState(null);
  const [form, setForm] = useState(vide());
  const [saving, setSaving] = useState(false);
  const save = async (next) => {
    setSaving(true);
    try { const r = await axios.put(`${API}/admin/espace/rubriques/modeles`, { modeles: next }, getAuthConfig()); setModeles(r.data.modeles); setEdit(null); }
    catch { alert('Erreur enregistrement'); }
    setSaving(false);
  };
  const f = (k) => (e) => setForm(s => ({ ...s, [k]: e.target.value }));
  const submit = (e) => { e.preventDefault(); if (!form.titre.trim()) return; save(edit === 'new' ? [...modeles, form] : modeles.map((m, i) => i === edit ? form : m)); };
  return (
    <Repli titre="📚 Modèles de rubriques" resume={modeles.length ? `${modeles.length} modèle(s) — à insérer dans n'importe quel voyage` : 'aucun modèle (ex. « Où nous retrouver », « Programme du jour »)'} testId="espace-rubriques-modeles"
      action={<button type="button" onClick={() => { setForm(vide()); setEdit('new'); }} className="text-xs px-2 py-0.5 rounded bg-emerald-600 text-white font-bold" data-testid="modele-add">➕ Modèle</button>}>
      <p className="text-[11px] text-gray-500 pt-1">Un modèle = une rubrique prête à l'emploi. Dans un voyage, « ➕ Ajouter » propose tes modèles ; ⭐ sur une rubrique existante l'enregistre ici.</p>
      <ul className="mt-1.5 space-y-1">
        {modeles.map((m, i) => (
          <li key={m.id} className="flex items-center gap-2 text-xs px-2 py-1 rounded-lg border bg-white border-gray-200" data-testid={`modele-${m.id}`}>
            <span className="font-semibold truncate">{m.icone} {m.titre}</span>
            {m.lien && <span className="text-gray-400">🔗</span>}
            <span className="ml-auto flex gap-1">
              <button type="button" onClick={() => { setForm({ ...vide(), ...m }); setEdit(i); }} className="px-1.5 rounded bg-white border border-gray-200" data-testid={`modele-edit-${m.id}`}>✏️</button>
              <button type="button" onClick={() => { if (window.confirm(`Supprimer le modèle « ${m.titre} » ? (les rubriques déjà insérées dans les voyages restent)`)) save(modeles.filter((_, j) => j !== i)); }} className="px-1.5 rounded bg-white border border-gray-200" data-testid={`modele-del-${m.id}`}>🗑</button>
            </span>
          </li>
        ))}
      </ul>
      {edit !== null && (
        <form onSubmit={submit} className="mt-2 bg-white border border-emerald-200 rounded-lg p-2 space-y-1.5" data-testid="modele-form">
          <div className="flex gap-1.5">
            <input value={form.icone} onChange={f('icone')} maxLength={4} className="w-12 text-center border rounded px-1 py-1 text-sm" title="Emoji" data-testid="modele-icone" />
            <input value={form.titre} onChange={f('titre')} placeholder="Titre (ex. Où nous retrouver)" required maxLength={80} className="flex-1 border rounded px-2 py-1 text-sm" data-testid="modele-titre" />
          </div>
          <textarea value={form.texte} onChange={f('texte')} rows={4} placeholder="Texte libre" className="w-full border rounded px-2 py-1 text-sm" data-testid="modele-texte" />
          <div className="flex gap-1.5">
            <input value={form.lien} onChange={f('lien')} placeholder="Lien (facultatif) https://…" className="flex-1 border rounded px-2 py-1 text-sm" data-testid="modele-lien" />
            <input value={form.lien_titre} onChange={f('lien_titre')} placeholder="Texte du bouton" maxLength={80} className="w-40 border rounded px-2 py-1 text-sm" data-testid="modele-lien-titre" />
          </div>
          <LiensEditor liens={form.liens || []} onChange={(l) => setForm(s => ({ ...s, liens: l }))} getAuthConfig={getAuthConfig} testPrefix="modele-piece" titre="📎 Photos & documents" aide="(plan, programme PDF…)" />
          <div className="flex gap-1.5 justify-end">
            <button type="button" onClick={() => setEdit(null)} className="text-xs px-2 py-1 rounded border border-gray-300">Annuler</button>
            <button type="submit" disabled={saving} className="text-xs px-3 py-1 rounded bg-[#1E3A5F] text-white font-bold" data-testid="modele-save">{saving ? '…' : '💾 Enregistrer'}</button>
          </div>
        </form>
      )}
    </Repli>
  );
};

export const sauverCommeModele = async (r, modeles, getAuthConfig) => {
  if (modeles.some(m => m.titre === r.titre) && !window.confirm(`Un modèle « ${r.titre} » existe déjà. En ajouter un second ?`)) return null;
  const { icone, titre, texte, lien, lien_titre, liens } = r;
  const res = await axios.put(`${API}/admin/espace/rubriques/modeles`, { modeles: [...modeles, { icone, titre, texte, lien, lien_titre, liens: liens || [] }] }, getAuthConfig());
  return res.data.modeles;
};
